import * as React from "react";
import { SVGProps } from "react";
const SvgMessenger01 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.5 8v8a4.5 4.5 0 0 0 4.288 4.495L13 20.5h3.833l2 1.5h-5.166L8.6 25.8A1 1 0 0 1 7 25v-3H6a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h2.5ZM26 5a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-2v3a1 1 0 0 1-1.6.8L17.333 19H13a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h13Zm0 2H13a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.667a1 1 0 0 1 .6.2L22 20v-2a1 1 0 0 1 1-1h3a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1Zm-7.017 7.086c.196 0 .376.044.53.122.332.17.546.501.546.906a.982.982 0 0 1-.547.894 1.164 1.164 0 0 1-.529.122c-.628 0-1.076-.435-1.076-1.016 0-.592.448-1.028 1.076-1.028Zm.072-6.324c1.67 0 2.564.968 2.564 2.177 0 1.608-1.604 2.016-1.765 3.131l-.013.183h-1.74c0-1.104.686-1.693 1.212-2.23.325-.332.59-.645.59-1.047 0-.376-.254-.653-.738-.653-.547 0-.754.298-.783.564l-.003.065-1.645-.182.002-.046c.018-1.022.676-1.962 2.32-1.962h-.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMessenger01;
